import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Text } from 'rebass';
import { createGlobalStyle } from 'styled-components';
import Banner from '../components/Banner';
import Footer from '../components/Footer';
import Header from '../components/Header';
import TextSection from '../components/TextSection';

const GlobalStyles = createGlobalStyle`
  html {
    background-color: black;
  }
`;

const P = ({ children }) => (
  <Text
    color="white"
    fontFamily="grot10"
    fontSize={['16px', '16px', '21px']}
    letterSpacing="-0.5px"
    lineHeight={['22px', '22px', '25px']}
    mb="12px"
  >
    {children}
  </Text>
);

const MentionsLegales = () => (
  <div>
    <GlobalStyles />
    <Helmet>
      <title>Mentions légales — Divine</title>
    </Helmet>
    <Banner invertColor />
    <Header activePageName="MENTIONS LÉGALES" invertColor />
    <Box
      css={{ maxWidth: '1500px' }}
      mx="auto"
      mt={['25px', '30px', '70px']}
      px={[20, 30, 70]}
    >
      <TextSection invertColor title="Éditeur du site">
        <Box>
          <P>
            Le site <strong>www.divine-musique.com</strong> est édité par la société{' '}
            <strong>DIVINE</strong>, société par actions simplifiée (SAS) au capital
            social de 2 420 €, immatriculée au Registre du Commerce et des Sociétés de
            Paris sous le numéro SIREN <strong>828 897 173</strong>.
          </P>
          <P>Siège social : 14 rue Favart, 75002 Paris, France</P>
          <P>Directeur de la publication : Antoine Renaud</P>
          <P>
            Contact :{' '}
            <a href="mailto:contact@divine-musique.com" style={{ color: 'white' }}>
              contact@divine-musique.com
            </a>
          </P>
        </Box>
      </TextSection>

      <TextSection invertColor title="Hébergement">
        <Box>
          <P>
            Le site est hébergé par <strong>Netlify, Inc.</strong>, dont le siège social
            est situé au 512 2nd Street, Suite 200, San Francisco, CA 94107, États-Unis.
          </P>
          <P>
            Site :{' '}
            <a
              href="https://www.netlify.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'white' }}
            >
              www.netlify.com
            </a>
          </P>
        </Box>
      </TextSection>

      <TextSection invertColor title="Propriété intellectuelle">
        <Box>
          <P>
            L'ensemble des éléments constituant le site www.divine-musique.com (textes,
            graphismes, photographies, images, vidéos, sons, plans, noms, logos, marques,
            créations et œuvres protégeables diverses, bases de données…) est la propriété
            exclusive de DIVINE ou de ses partenaires, et est protégé par les lois françaises
            et internationales relatives à la propriété intellectuelle.
          </P>
          <P>
            Toute reproduction, représentation, modification, publication, adaptation de tout
            ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé,
            est interdite, sauf autorisation écrite préalable de DIVINE.
          </P>
          <P>
            Toute exploitation non autorisée du site ou de l'un quelconque des éléments
            qu'il contient sera considérée comme constitutive d'une contrefaçon et poursuivie
            conformément aux dispositions des articles L.335-2 et suivants du Code de la
            propriété intellectuelle.
          </P>
        </Box>
      </TextSection>

      <TextSection invertColor title="Liens hypertextes">
        <Box>
          <P>
            Le site www.divine-musique.com peut contenir des liens hypertextes vers d'autres
            sites. DIVINE ne dispose d'aucun moyen pour contrôler les sites en connexion avec
            son site internet, et ne répond pas de la disponibilité de tels sites et sources
            externes, ni ne la garantit.
          </P>
          <P>
            DIVINE ne peut être tenue pour responsable de tout dommage, de quelque nature que
            ce soit, résultant du contenu de ces sites ou sources externes.
          </P>
        </Box>
      </TextSection>

      <TextSection invertColor title="Responsabilité">
        <Box>
          <P>
            Les informations fournies sur le site www.divine-musique.com le sont à titre
            indicatif et ne sauraient dispenser l'utilisateur d'une analyse complémentaire
            et personnalisée.
          </P>
          <P>
            DIVINE s'efforce d'assurer au mieux l'exactitude et la mise à jour des
            informations diffusées sur ce site. Toutefois, DIVINE ne peut garantir
            l'exactitude, la précision ou l'exhaustivité des informations mises à disposition
            sur ce site.
          </P>
        </Box>
      </TextSection>

      <TextSection invertColor title="Droit applicable">
        <Box>
          <P>
            Le présent site et les présentes mentions légales sont soumis au droit français.
            En cas de litige, les tribunaux français seront seuls compétents.
          </P>
        </Box>
      </TextSection>

      <TextSection invertColor title="Médiation" isLast>
        <Box>
          <P>
            Conformément aux dispositions du Code de la consommation concernant le règlement
            amiable des litiges, DIVINE adhère au Service du Médiateur du e-commerce de la
            FEVAD (Fédération du e-commerce et de la vente à distance).
          </P>
        </Box>
      </TextSection>
    </Box>
    <Footer activePageName="MENTIONS LÉGALES" invertColor />
  </div>
);

export default MentionsLegales;
